import { render } from "./responses-table-entry.vue?vue&type=template&id=0009520a&lang=pug"
import script from "./responses-table-entry.vue?vue&type=script&setup=true&lang=js"
export * from "./responses-table-entry.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__